import React, { Component } from 'react';
import * as Kyousai from './Saga/Kyousai';
import { connect } from 'react-redux';
import TextField from '@material-ui/core/TextField';
import Dropzone from 'react-dropzone';
import Backdrop from '@material-ui/core/Backdrop';
import CircularProgress from '@material-ui/core/CircularProgress';
// import * as Customers from '../../Store/Customers';
// import * as Responses from '../../Store/Responses';
// import * as Monies from '../../Store/Monies';
import DateFnsUtils from '@date-io/date-fns';
// import "Components/RentMoney___/node_modules/react-datepicker/dist/react-datepicker.css";
import ja from "date-fns/locale/ja";
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
// import { Field} from 'redux-form';
import './Css/Kyousai.css';
import { withStyles } from '@material-ui/core/styles';

const styles = (theme: any) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
  },
});
// import DatePicker from "react-datepicker";

const { MuiPickersUtilsProvider, KeyboardDatePicker } = require('@material-ui/pickers');
interface Props {

  // handleSubmit:any,
  // onSubmit:any,
  // get_rent_contract_accounting:any,
  // output:any,
  // name:string,
  // date1:string,
  // date2:string,
  update_kyousai_comp: any,
  upload_kyousai_csv: any,
  classes: any,
  csv_loading: boolean,
  change_search_list: any,
  search_list: any,
  get_kyousais: any,
  matching: any,
  delete_kyousais: any,
  all_select: any,
  kyousais: any,
  get_kyousais_csv: any,
}


interface State {
  refresh: boolean

}


class KyousaiSearch extends Component<Props, State> {

  constructor(props: Readonly<Props>) {
    super(props);
    this.state = {
      refresh: false
    }
    this.onDrop = this.onDrop.bind(this);
    this.onChange = this.onChange.bind(this);
    this.onChangeStartDate = this.onChangeStartDate.bind(this);
    this.onChangeEndDate = this.onChangeEndDate.bind(this);

    this.handle_change_search_completed = this.handle_change_search_completed.bind(this);
    this.handle_change_search_deleted = this.handle_change_search_deleted.bind(this);

  }
  onDrop = (files: any) => {
    console.log(files)
    const file = files[0]
    const reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = () => {
      // this.setState({
      //   base64: reader.result,
      //   name: file.name,

      // })
    }

    let sendfile: any = [];
    sendfile.window = window;
    sendfile.file = files;
    // sendfile.id=this.props.introduction_file_id;
    this.props.upload_kyousai_csv(sendfile)


    // this.props.add_introduction_file(sendfile)
  };


  componentWillMount() {

    // this.props.initialize({output:true,name:"",date1:"",date2:""});//フォームに初期値を反映させる


  }

  onChange(e: any) {

    let search_list = this.props.search_list
    search_list[e.target.name] = e.target.value
    // this.props.search_list
    // this.props.change_search_list()
  }

  onChangeStartDate(e: any) {
    let search_list = this.props.search_list
    search_list.start_date = e
    this.props.change_search_list(search_list)
    this.setState({ refresh: !this.state.refresh })
  }

  onChangeEndDate(e: any) {

    let search_list = this.props.search_list
    search_list.end_date = e
    this.props.change_search_list(search_list)
    this.setState({ refresh: !this.state.refresh })
  }


  handle_change_search_completed(e: any) {

    let search_list = this.props.search_list
    search_list.search_deleted = false
    search_list.search_completed = e.target.checked
    if (e.target.checked) {
      let dt = new Date();
      let month = dt.getMonth() + 1;
      //1ヶ月前
      let lastMonth = dt.setMonth(month - 2);
      search_list.start_date = lastMonth
      search_list.end_date = null
    } else {
      search_list.start_date = null
      search_list.end_date = null
    }
    this.props.change_search_list(search_list)
    this.setState({ refresh: !this.state.refresh })

  }

  handle_change_search_deleted(e: any) {

    let search_list = this.props.search_list
    search_list.search_completed = false
    search_list.search_deleted = e.target.checked
    if (e.target.checked) {
      let dt = new Date();
      let month = dt.getMonth() + 1;
      //1ヶ月前
      let lastMonth = dt.setMonth(month - 2);
      search_list.start_date = lastMonth
      search_list.end_date = null
    } else {
      search_list.start_date = null
      search_list.end_date = null
    }
    this.props.change_search_list(search_list)
    this.setState({ refresh: !this.state.refresh })

  }

  render() {

    // const { handleSubmit } = this.props;


    return (
      <div>
        {/* <form onSubmit={handleSubmit}  > */}
        <table>

          <tbody>

            <tr >
              <th>お客様名</th>
              <td >
                <TextField
                  name="name"
                  onChange={this.onChange}
                  onKeyDown={e => {
                    if (e.keyCode === 13) {
                      // エンターキー押下時の処理
                      this.props.get_kyousais()
                    }
                  }}
                  //   component="input"
                  type="text"
                  //placeholder=""
                  className="form-control"
                />
              </td>
              <th>物件名</th>
              <td >
                <TextField
                  name="tatemono_name"
                  onChange={this.onChange}
                  onKeyDown={e => {
                    if (e.keyCode === 13) {
                      // エンターキー押下時の処理
                      this.props.get_kyousais()
                    }
                  }}
                  //   component="input"
                  type="text"
                  //placeholder=""
                  className="form-control"
                />
              </td>
              <td rowSpan={2}>

                <div style={{ width: "300px", marginLeft: "30px", height: "80px" }}>
                  <Dropzone

                    onDrop={this.onDrop}>
                    {({ getRootProps, getInputProps }) => (

                      <div {...getRootProps({ className: 'dropzone' })} style={{ background: "#f5f5f5" }}>

                        <input {...getInputProps()} />

                        <div style={{ height: 40, }}>
                          <p>きょうさいCSV　クリックまたはドラッグ</p>
                          <ul style={{ padding: 0 }}  >
                            {/* {this.props.mail_detail_files.map(file => (
<li className="filename" key={file.id} >
<span onClick={(e)=>this.downloadfile(e,file)}>{file.name}</span> <span onClick={(e)=>this.deletefile(e,file)} className="fas fa-times float-right" />

</li>))} */}

                          </ul>

                        </div>

                      </div>

                    )}
                  </Dropzone>
                </div>



              </td>

            </tr>


            {/* <tr >
                          <th>データ未作成</th>
                          <td >   
                          <Field name="output" id="output" component="input"  type="checkbox"/>

                          
                          </td>
                              </tr > */}


            <tr >
              <th>始期日：</th>
              <td colSpan={3}>
                <MuiPickersUtilsProvider utils={DateFnsUtils} locale={ja}>


                  <KeyboardDatePicker
                    disableToolbar
                    variant="inline"
                    format="yyyy/MM/dd"
                    margin="normal"
                    id="date-picker-estimate2"
                    label="始期日"
                    //   showTodayButton={true}
                    style={{ float: "left" }}
                    onChange={this.onChangeStartDate}
                    autoOk={true}
                    // error={true}
                    // helperText="契約日を選択してください"
                    //   errorMessages={['契約日を選択してください']}
                    name="start_date"
                    value={this.props.search_list.start_date}
                    //    onChange={this.handleContractionDateChangeStart}
                    //    value={this.props.estimate_search.contractDateStart}
                    //    value={this.props.estimateData.contractDate}
                    //              onChange={this.handleContractionDateChange}
                    KeyboardButtonProps={{
                      'aria-label': 'change date',
                    }}
                    //   minDateMessage="契約日を選択してください"
                    // minDate={new Date("2000-01-01")}
                    invalidDateMessage={"日付の形式が違います"}
                  />
                  ～
                  <KeyboardDatePicker

                    disableToolbar
                    variant="inline"
                    format="yyyy/MM/dd"
                    margin="normal"
                    id="date-picker-estimate2"
                    label="始期日"
                    style={{ marginLeft: "20px" }}
                    value={this.props.search_list.end_date}
                    onChange={this.onChangeEndDate}
                    autoOk={true}
                    // error={true}
                    // helperText="申込日を選択してください"
                    //   showTodayButton={true}
                    //  name ="applicationDate"
                    name="end_date"
                    //  value={this.props.estimate_search.contractDateEnd}
                    // //  value={this.props.estimateData.applicationDate}
                    //  onChange={this.handleContractionDateChangeEnd}
                    KeyboardButtonProps={{
                      'aria-label': 'change date',
                    }}
                    invalidDateMessage={"日付の形式が違います"}
                  />

                </MuiPickersUtilsProvider>


                <FormControlLabel
                  control={
                    <Checkbox
                      checked={this.props.search_list.search_completed}
                      onChange={this.handle_change_search_completed}
                      name="search_completed"
                      color="primary"

                    />
                  }
                  label="チェック済"
                  style={{ marginTop: "20px", marginLeft: "60px" }}
                />



                <FormControlLabel
                  control={
                    <Checkbox
                      checked={this.props.search_list.search_deleted}
                      onChange={this.handle_change_search_deleted}
                      name="search_deleted"
                      color="primary"

                    />
                  }
                  label="消込"
                  style={{ marginTop: "20px", marginLeft: "60px" }}
                />
              </td>

            </tr >





            <tr >
              <td colSpan={4}>
                <button
                  onClick={this.props.all_select}
                  type="button"
                  style={{ marginTop: "5px" }}
                  className="btn btn-sm btn-success float-left"
                >全選択・解除</button>


                <button
                  type="button"
                  style={{ margin: "5px" }}
                  className="btn btn-primary float-left"
                  onClick={this.props.update_kyousai_comp}
                >登録</button>

                <button
                  type="submit"
                  style={{ margin: "5px" }}
                  className="btn btn-primary float-right"
                  onClick={this.props.get_kyousais}
                >検索</button></td>
              <td>
                <button
                  onClick={this.props.matching}
                  style={{ margin: "5px" }}
                  className="btn btn-warning float-right"
                >自動マッチング</button>


                <button
                  onClick={this.props.delete_kyousais}
                  style={{ margin: "5px" }}
                  className="btn btn-danger float-right"
                >消込</button>


                <button
                  onClick={this.props.get_kyousais_csv}
                  style={{ margin: "5px" }}
                  className="btn btn-success float-right"
                >CSV</button>

                <span style={{ margin: "10px" }}>{this.props.kyousais.length}件</span>
              </td>

            </tr >
          </tbody>
        </table>




        {/* </form> */}



        <Backdrop className={this.props.classes.backdrop} open={this.props.csv_loading}>
          <CircularProgress color="inherit" />
        </Backdrop>

      </div>
    );
  }
}




const mapStateToProps = (state: any) => {
  return {

    // responseid: state.customersReducer.responseid,
    // responsedetail: state.customersReducer.responsedetail,
    // customerNewDisp: state.customersReducer.customerNewDisp,
    csv_loading: state.kyousaiReducer.csv_loading,
    search_list: state.kyousaiReducer.search_list,
    kyousais: state.kyousaiReducer.kyousais,
  }
}
function mapDispatchToProps(dispatch: any) {
  return {

    upload_kyousai_csv(state: any) {
      dispatch(Kyousai.upload_kyousai_csv(state))
    },

    update_kyousai_comp(state: any) {
      dispatch(Kyousai.update_kyousai_comp(state))
    },
    change_search_list(state: any) {
      dispatch(Kyousai.change_search_list(state))
    },
    get_kyousais(state: any) {
      dispatch(Kyousai.get_kyousais(state))
    },
    matching(state: any) {
      dispatch(Kyousai.matching(state))
    },
    delete_kyousais(state: any) {
      dispatch(Kyousai.delete_kyousais(state))
    },
    all_select(state: any) {
      dispatch(Kyousai.all_select(state))
    },
    get_kyousais_csv(state: any) {
      dispatch(Kyousai.get_kyousais_csv(state))
    },

  };
}

export default withStyles(styles)(connect(mapStateToProps, mapDispatchToProps)(KyousaiSearch));

// AccountingListSearchComponent = connect(
//     mapStateToProps, mapDispatchToProps
// )(AccountingListSearchComponent);
// export default  reduxForm<Props>({
//     form: 'formset',

// })(AccountingListSearchComponent);
// const form = reduxForm({
//     form: 'formset', // a unique identifier for this form

//     //enableReinitialize: true, // initialValuesプロップが更新されると、フォームも更新されます。
// })(KyousaiSearch)

// export default Form;

